var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "event" } }, [
    _c("div", { staticClass: "stamp" }, [
      _c("img", {
        attrs: { src: require("@/assets/event/stamp/stamp.jpg"), alt: "" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "button left",
        on: {
          click: function ($event) {
            return _vm.onClickbutton("https://sourl.co/YGBrxy")
          },
        },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "button right",
        on: {
          click: function ($event) {
            return _vm.onClickbutton("https://sourl.co/YcvfTF")
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }